/**
 * SEO Settings block — meta title, description, OG image, favicon,
 * Google Analytics ID, Facebook Pixel ID.
 */
import FileUpload from "@/components/churchbuilder/FileUpload";

const inp = "w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-3 py-2.5 rounded text-sm text-white";

export default function SeoSettingsBlock({ churchId, church, onChange, onSave }) {
  const update = (patch) => {
    const next = { ...church, ...patch };
    onChange(next);
  };
  const blur = () => onSave(church);

  return (
    <div data-testid="block-seo" className="luxury-card rounded-xl p-5 space-y-4">
      <div className="font-serif-display text-xl">SEO & Tracking</div>
      <div className="text-xs text-neutral-500 -mt-2">These render in the &lt;head&gt; of your public church site so Google, social shares and analytics pick them up.</div>

      <Field label="Meta Title (max 60 chars)" hint={`${(church.meta_title || "").length}/60`}>
        <input data-testid="seo-meta-title" value={church.meta_title || ""} maxLength={60} onChange={(e) => update({ meta_title: e.target.value })} onBlur={blur} className={inp} placeholder={`${church.name || "Church Name"} | Worship · Community`} />
      </Field>

      <Field label="Meta Description (max 160 chars)" hint={`${(church.meta_description || "").length}/160`}>
        <textarea rows={3} data-testid="seo-meta-description" value={church.meta_description || ""} maxLength={160} onChange={(e) => update({ meta_description: e.target.value })} onBlur={blur} className={inp} placeholder="Join us for Sunday worship, weekday Bible study and community events." />
      </Field>

      <div className="grid sm:grid-cols-2 gap-5">
        <FileUpload churchId={churchId} value={church.og_image_url} onChange={(url) => { update({ og_image_url: url }); onSave({ ...church, og_image_url: url }); }} label="OpenGraph share image (1200×630)" testid="seo-og-image" />
        <FileUpload churchId={churchId} value={church.favicon_url} onChange={(url) => { update({ favicon_url: url }); onSave({ ...church, favicon_url: url }); }} label="Custom favicon (square, 64×64+)" testid="seo-favicon" />
      </div>

      <div className="grid sm:grid-cols-2 gap-5">
        <Field label="Google Analytics ID" hint="e.g. G-XXXXXXXXXX">
          <input data-testid="seo-ga-id" value={church.google_analytics_id || ""} onChange={(e) => update({ google_analytics_id: e.target.value })} onBlur={blur} className={inp} placeholder="G-XXXXXXXXXX" />
        </Field>
        <Field label="Facebook Pixel ID" hint="numeric only">
          <input data-testid="seo-fb-pixel" value={church.facebook_pixel_id || ""} onChange={(e) => update({ facebook_pixel_id: e.target.value })} onBlur={blur} className={inp} placeholder="1234567890123456" />
        </Field>
      </div>
    </div>
  );
}

function Field({ label, hint, children }) {
  return (
    <div>
      <div className="flex items-center justify-between">
        <label className="text-[10px] tracking-widest uppercase text-neutral-400">{label}</label>
        {hint && <span className="text-[10px] text-neutral-600">{hint}</span>}
      </div>
      <div className="mt-1">{children}</div>
    </div>
  );
}
